import { useFormik } from "formik";
import { get, uniqBy } from "lodash";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";
import { NAME_SPACES } from "shared/locales/constants";
import { bindInputProps } from "utils/helpers/input";
import ActionButtons from "../Components/ActionButtons";
import DocumentDownload from "../Components/DocumentDownload";
import Footer from "../Components/Footer";
import Head from "../Components/Head";
import InfoBox from "../Components/InfoBox";
import Input from "../Components/Input";
import Layout from "../Components/Layout";
import MemberInfo from "../Components/MemberInfo";
import PricingItem from "../Components/PricingItem";
import validation from "./validation";

const View = ({
  generalCost,
  attachments,
  project,
  subscription,
  onSubmit,
  download,
  onEdit,
  onBack,
  loading,
}) => {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.PROCESSES);
  const TRANSLATION = t("B2C_LMF.CONTRACT", { returnObjects: true });
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const { handleSubmit, values, setFieldValue, ...formProps } = useFormik({
    initialValues: {
      contact: {
        id: get(project, "contact.id"),
        fields: get(project, "contact.fields"),
      },
    },
    onSubmit,
    validationSchema: validation(
      t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true }),
    ),
  });

  const allCheckboxesChecked =
    get(values, "contact.fields.acceptTerms", false) &&
    get(values, "contact.fields.digitalConsent", false) &&
    get(values, "contact.fields.honorDeclaration", false);
  // get(values, "contact.fields.earlyExecConsent", false);

  return (
    <>
      <Layout>
        <Head
          description={TRANSLATION.DESCRIPTION}
          title={TRANSLATION.TITLE}
          onBack={onBack}
        />
        <div className="lmf__contract">
          <div className="lmf__contract--content pb-24">
            <div className="lmf__contract--content--column">
              <PricingItem
                title={get(generalCost, "insurancePlan.name")}
                price={get(generalCost, "cost")}
                currency={get(generalCost, "currency")}
                per={"par mois"}
                breakdown={get(
                  project,
                  `fields.upsells.${get(subscription, "insurancePlan.id")}`,
                )}
              />
              <DocumentDownload
                title={
                  "Vous pouvez consultez les documents relatifs à votre devis"
                }
                items={uniqBy(attachments, "name")}
                download={(id) => download(id)}
              />
              <InfoBox
                variant="danger"
                text={
                  "Je bénéficie de la possibilité de renoncer à mon adhésion dans un délai de 14 jours calendaires à compter de la signature de mon bulletin d’adhésion"
                }
              />
            </div>
            <div className="divider"></div>
            <div className="lmf__contract--content--column">
              <MemberInfo data={subscription} onEdit={(v) => onEdit(v)} />
            </div>
          </div>
          <div className="lmf__contract--infos">
            <span className="lmf__contract--infos--title">
              {TRANSLATION.OPT_INS_TITLE}
            </span>

            <div className="lmf__contract--infos--body">
              {/* <span>{TRANSLATION.OPT_INS.DOCUMENTS.TITLE}</span> */}
              <div>
                <Input
                  type="checkbox"
                  label={
                    get(
                      TRANSLATION,
                      `OPT_INS.DOCUMENTS.ACCEPT_TERMS_${get(
                        subscription,
                        "insurancePlan.category",
                      )}`,
                    ) || TRANSLATION.OPT_INS.DOCUMENTS.ACCEPT_TERMS_A
                  }
                  checked={get(values, "contact.fields.acceptTerms", false)}
                  {...bindInputProps({
                    name: "contact.fields.acceptTerms",
                    values,
                    setFieldValue,
                    ...formProps,
                  })}
                />
                <Input
                  type="checkbox"
                  label={TRANSLATION.OPT_INS.DOCUMENTS.HONOR_DECLARATION}
                  checked={get(
                    values,
                    "contact.fields.honorDeclaration",
                    false,
                  )}
                  {...bindInputProps({
                    name: "contact.fields.honorDeclaration",
                    values,
                    setFieldValue,
                    ...formProps,
                  })}
                />
                <Input
                  type="checkbox"
                  label={TRANSLATION.OPT_INS.DOCUMENTS.DIGITAL_CONSENT}
                  checked={get(values, "contact.fields.digitalConsent", false)}
                  {...bindInputProps({
                    name: "contact.fields.digitalConsent",
                    values,
                    setFieldValue,
                    ...formProps,
                  })}
                />
                <Input
                  type="checkbox"
                  label={TRANSLATION.OPT_INS.DOCUMENTS.EARLY_EXEC_CONSENT}
                  checked={get(
                    values,
                    "contact.fields.earlyExecConsent",
                    false,
                  )}
                  {...bindInputProps({
                    name: "contact.fields.earlyExecConsent",
                    values,
                    setFieldValue,
                    ...formProps,
                  })}
                />
              </div>
            </div>
            <ActionButtons
              disabled={!allCheckboxesChecked}
              onNext={handleSubmit}
              buttonText={TRANSLATION.NEXT}
              loading={loading}
              title={!allCheckboxesChecked ? TRANSLATION.WARNING : ""}
              {...(isMobile && { onBack })}
              className="w-100"
            />
            {/* <Button
              disabled={!allCheckboxesChecked}
              onClick={handleSubmit}
              type={allCheckboxesChecked ? "primary" : "white"}
              size="medium"
              className="w-full"
            >
              <span>{TRANSLATION.NEXT}</span>
            </Button> */}
          </div>

          <Footer variant="left" type="signature" />
        </div>
      </Layout>
    </>
  );
};

export default View;
